const products = [
  {
    image: "/img/tshirt.jpeg",
    header: "Blue t-shirt",
    description: "Some description about this product",
    price: 40.50
  },
  {
    image: "/img/tshirt.jpeg",
    header: "Same but better",
    description: "Some description about this product",
    price: 50.99
  },
  {
    image: "/img/pierogie.jpg",
    header: "Pierogies",
    description: "Filled dumplings from Poland",
    price: 25.36
  },
  {
    image: "/img/dala.jpeg",
    header: "Dala Horse",
    description: "Traditional carved, painted wooden statue",
    price: 999.99
  },
  {
    image: "/img/ice.jpg",
    header: "Ice cream",
    description: "Glass full of svenska glass",
    price: 20.30
  },    
]

export default products